import { render } from "./TeamNewsfeed.vue?vue&type=template&id=7dc3b34a"
import script from "./TeamNewsfeed.vue?vue&type=script&lang=js"
export * from "./TeamNewsfeed.vue?vue&type=script&lang=js"

import "./TeamNewsfeed.vue?vue&type=style&index=0&id=7dc3b34a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__